import styled, { css } from "styled-components";
import { Paper } from "../Paper";
import { AlertRootProps } from "../../react-components-core";
import { getLuminance } from "../../react-utils";

export const AlertRoot = styled(Paper)<AlertRootProps>(({ theme, type, closed, hasAlertClick }) => {
    const backgroundColor = type && type !== "loading" ? theme.palette.status[type] : theme.palette.background;

    return css`
        display: ${closed ? "none" : "flex"};
        align-items: center;
        flex-wrap: wrap;

        box-sizing: border-box;
        width: auto;
        min-height: 56px;
        padding: 14px;
        border-radius: ${theme.borderRadius};
        background-color: ${backgroundColor};
        color: ${getLuminance(backgroundColor) > 0.5 ? "#000" : "#FFF"};
        cursor: ${hasAlertClick ? "pointer" : "inherit"};
        svg {
            font-size: 18px;
        }
    `;
});

export const AlertCloseButton = styled.button`
    display: inline-block;
    font-size: 19px;
    line-height: 1;
    border: none;
    background: transparent;
    cursor: pointer;
    transform-origin: center;
    transform: scaleX(1.3);
    padding: 0px;
`;

export const AlertAction = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
`;
